import PropTypes from 'prop-types';

import { makePaymentSBP } from '../../../api/ans';
import { getOwnerBalanceThunk } from '../../../store/slices/paymentsSlice';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { loadCloudPayments } from '../../../utils/cloudPayments';
import { parseAmountForCP, waitAndUpdateBalance } from '../../../utils/functions';
import useSubmitLock from '../../../utils/useSubmitLock';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function OtherPaymentsPopup({ onRequestClose }) {
  const dispatch = useAppDispatch();
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const context = popupProps?.context;
  const rawAmount = popupProps?.amount; // извлекаем сразу
  const amount = parseAmountForCP(rawAmount);
  const user = useAppSelector((state) => state.user.data);
  const { isSubmitting, run } = useSubmitLock();
  const publicIdCP = process.env.REACT_APP_CLOUD_PAYMENTS_PUBLIC_ID;
  console.log(amount);
  // Раньше здесь было dispatch(closePopup()) + navigate('/') - крестик
  // уводил на главную, а клик по фону/Escape (через ModalWrapper) просто
  // закрывал попап без перехода. onRequestClose приходит из ModalWrapper
  // и делает ровно то же самое, что клик по фону - см. тот же паттерн в
  // SuccessPopup/ErrorOrderPopup. Этот попап открывается без onCloseHref,
  // так что оба пути (крестик и фон) теперь просто закрывают, без
  // перехода на главную.
  const handleClosePopup = onRequestClose || (() => dispatch(closePopup()));

  const payByCard = async () => {
    let CloudPaymentsWidget;
    try {
      CloudPaymentsWidget = await loadCloudPayments();
    } catch (err) {
      console.error(err);
      dispatch(
        openPopup({
          name: 'error',
          props: {
            errorText:
              'Не удалось загрузить форму оплаты. Проверьте соединение и попробуйте снова.',
            buttonText: 'Продолжить',
          },
        })
      );
      return;
    }
    const widget = new CloudPaymentsWidget({
      sbpSupport: false,
    });
    widget.pay(
      'auth',
      {
        publicId: publicIdCP,
        amount,
        currency: 'RUB',
        accountId: user.id,
        email: user.email,
        skin: 'modern',
        phone: user.phone,
        description: context === 'services' ? 'services' : 'storage',
      },
      {
        onSuccess: async (options) => {
          console.log('Успешно:', options);
          const ok = waitAndUpdateBalance(user.id, dispatch, 10);
          dispatch(getOwnerBalanceThunk(user.id));
          if (ok) dispatch(closePopup('otherPayments'));
          else console.warn('⚠ Баланс не обновился вовремя');
        },
        onFail: (reason, options) => {
          console.error('Отмена или ошибка:', reason, options);
        },
      }
    );
  };

  const paySBP = async () => {
    await makePaymentSBP({
      amount,
      pay_type: context === 'services' ? 'services' : 'storage',
    })
      .then((value) => {
        window.open(value.QrUrl, '_blank');
        console.log('✅ Успешно:', value);
        dispatch(getOwnerBalanceThunk(user.id));
        const ok = waitAndUpdateBalance(user.id, dispatch, 10);
        if (ok) dispatch(closePopup('otherPayments'));
        else console.warn('⚠ Баланс не обновился вовремя');
        dispatch(closePopup('otherPayments'));
      })
      .catch((error) => {
        console.error('❌ Ошибка при оплате:', error);

        // Проверяем тип ошибки — отмена пользователем или сбой сети
        if (error?.message?.toLowerCase().includes('cancel')) {
          console.warn('Пользователь отменил оплату');
        } else {
          alert('Произошла ошибка при оплате. Пожалуйста, попробуйте снова.');
        }
      });
  };

  // Повторный клик, пока платёж создаётся, игнорируется (иначе два платежа)
  const handleSBPPay = () => run(paySBP);
  const handleCardsPay = () => run(payByCard);

  return (
    <div className={styles.successPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
        <div className={styles.successTextWrapper}>
          <h3 className={styles.successSubTitle}>Другие способы оплаты</h3>
        </div>
        <RedButton
          text="Оплата по СБП"
          onClick={handleSBPPay}
          width={308}
          height={54}
          disabled={isSubmitting}
        />
        <RedButton
          text="Оплата по карте"
          onClick={handleCardsPay}
          width={308}
          height={54}
          disabled={isSubmitting}
        />
      </div>
    </div>
  );
}

OtherPaymentsPopup.propTypes = {
  onRequestClose: PropTypes.func,
};

export default OtherPaymentsPopup;
